import request from './request';

/**
 * Service pour la gestion des élèves
 */
class EleveService {
  
  /**
   * Récupère la liste de tous les élèves
   * @returns {Promise} - Promesse contenant la liste des élèves
   */
  async getAll() {
    try {
      const response = await request.get('/utilisateurs?profilep=eleve');
      console.log('Élèves récupérés:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des élèves:', error);
      throw error;
    }
  }

  /**
   * Récupère un élève par son ID
   * @param {string|number} eleveId - ID de l'élève
   * @returns {Promise} - Promesse contenant les données de l'élève
   */
  async getById(eleveId) {
    try {
      const response = await request.get(`/utilisateurs/profilep/eleve/${eleveId}`);
      console.log('Élève récupéré:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de l\'élève:', error);
      throw error;
    }
  }

  /**
   * Récupère les élèves d'une classe spécifique
   * @param {string|number} classeId - ID de la classe
   * @returns {Promise} - Promesse contenant la liste des élèves de la classe
   */
  async getByClasse(classeId) {
    try {
      const response = await request.get(`/classes/${classeId}/eleves`);
      console.log('Élèves de la classe récupérés:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des élèves de la classe:', error);
      throw error;
    }
  }

  /**
   * Recherche des élèves par nom ou prénom
   * @param {string} searchTerm - Terme de recherche
   * @returns {Promise} - Promesse contenant la liste des élèves trouvés
   */
  async search(searchTerm) {
    try {
      const response = await request.get(`/utilisateurs/profilep/eleve/search?q=${encodeURIComponent(searchTerm)}`);
      console.log('Résultats de recherche élèves:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la recherche d\'élèves:', error);
      throw error;
    }
  }
}

/**
 * Service pour la gestion des classes
 */
class ClasseService {
  
  /**
   * Récupère la liste de toutes les classes
   * @returns {Promise} - Promesse contenant la liste des classes
   */
  async getAll() {
    try {
      const response = await request.get('/classes');
      console.log('Classes récupérées:', response.data);
      return response;
    } catch (error) {
      console.error('Erreur lors de la récupération des classes:', error);
      throw error;
    }
  }

  /**
   * Récupère une classe par son ID
   * @param {string|number} classeId - ID de la classe
   * @returns {Promise} - Promesse contenant les données de la classe
   */
  async getById(classeId) {
    try {
      const response = await request.get(`/classes/${classeId}`);
      console.log('Classe récupérée:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération de la classe:', error);
      throw error;
    }
  }

  /**
   * Récupère les matières d'une classe
   * @param {string|number} classeId - ID de la classe
   * @returns {Promise} - Promesse contenant les matières de la classe
   */
  async getMatieres(classeId) {
    try {
      const response = await request.get(`/classes/${classeId}/matieres`);
      console.log('Matières de la classe récupérées:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des matières de la classe:', error);
      throw error;
    }
  }

  /**
   * Récupère les statistiques d'une classe
   * @param {string|number} classeId - ID de la classe
   * @returns {Promise} - Promesse contenant les statistiques de la classe
   */
  async getStats(classeId) {
    try {
      const response = await request.get(`/classes/${classeId}/stats`);
      console.log('Statistiques de la classe récupérées:', response.data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des statistiques de la classe:', error);
      throw error;
    }
  }
}

export const eleveService = new EleveService();
export const classeService = new ClasseService();
export { EleveService, ClasseService };
